<template>
  <el-dialog :title="isAdd ? '新增型号' : '编辑型号'" :visible.sync="viewVisible" width="650px" :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto">
        <el-form-item label="设备类型" prop="category">
          <el-select v-model="ruleForm.category" style="width:400px;" filterable clearable>
            <el-option v-for="(item, index) in catList" :key="index" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="设备型号" prop="name">
          <el-input v-model="ruleForm.name"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :style="{ color: buttonTextColor }" @click="handleClose">取 消</el-button>
      <el-button :style="{ color: buttonTextColor }" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        id: null,
        category: null,
        name: ""
      },
      catList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请选择设备型号",
            trigger: "blur",
          },
        ],
        category: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "blur",
          },
        ]
      },
    };
  },
  watch: {
    viewVisible(newVal) {
      if (newVal) {
        this.categoryList();
        if (this.isAdd) {
          //新增
          this.ruleForm.id = null;
          this.ruleForm.category = null;
          this.ruleForm.name = "";
        } else {
          //修改
          this.ruleForm.id = this.currentData.id;
          this.ruleForm.category = this.currentData.category;
          this.ruleForm.name = this.currentData.name;
        }
      }
    },
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["viewVisible", "currentData", "isAdd"],
  methods: {
    //查询类型列表
    categoryList() {
      var params={
        pageNum: 1,        
        pageSize: 200, 
      }
       this.request.categoryList(params).then((res) => {
          if (res.code==0) {
            this.catList = res.data;
          }
       });
    },
    handleClose() {
      this.ruleForm = {
        id: null,
        category: null,
        name: ""
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("viewClose");
    },
    //提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.request.modelAdd(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$message.success("新增成功");
                this.$emit("modelList");
                this.handleClose();
              }
            });
          } else {
            this.request.modelEdit(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$message.success("编辑成功");
                this.$emit("modelList");
                this.handleClose();
              }
            });
          }
        }
      });
    },
  },
};
</script>


<style scoped>
.from-body {
  padding: 0 60px;
  box-sizing: border-box;
}
</style>